import { render, staticRenderFns } from "./View.vue?vue&type=template&id=477ef7e0&scoped=true&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"
import style0 from "./View.vue?vue&type=style&index=0&id=477ef7e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ef7e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('477ef7e0')) {
      api.createRecord('477ef7e0', component.options)
    } else {
      api.reload('477ef7e0', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=477ef7e0&scoped=true&", function () {
      api.rerender('477ef7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Doc/View.vue"
export default component.exports